import {
    USER_CREATE_FAILED,
    USER_CREATE_LOAD,
    USER_CREATE_LOADING,
    USER_CREATE_SUCCESS, USER_HIDE_MODAL, USER_SHOW_MODAL
} from "../constants/UserCreateConst";
import {BRANCH_HIDE_MODAL, BRANCH_SHOW_MODAL} from "../../../masterdata/redux/constants/BranchConst";

export const success = (data) => {
    return {
        type: USER_CREATE_SUCCESS,
        data
    }
};

export const failed = () => {
    return {
        type: USER_CREATE_FAILED
    }
};

export const loading = () => {
    return {
        type: USER_CREATE_LOADING
    };
};

export const createuser = (data) => {
    return {
        type: USER_CREATE_LOAD,
        data
    };
};

export const showModal = (data) => {
    return {
        type: USER_SHOW_MODAL,
    }
};

export const hideModal = (data) => {
    return {
        type: USER_HIDE_MODAL,
    }
};




